import { useQuery } from '@apollo/client';
import type {
  Course_Course as CourseType,
  Partner_Partner as PartnerType,
  Specialization_Specialization as SpecializationType,
} from '__generated__/graphql-types-do-not-use';

import getCourseByIdForCheckoutPage from 'bundles/payments-common/api/GetCourseById.graphql';
import type {
  GetCourseByIdForCheckoutPageQuery,
  GetCourseByIdForCheckoutPageQueryVariables,
} from 'bundles/payments-common/api/__generated__/GetCourseById';

type Partners =
  | ({ __typename?: 'Partner_Partner' } & Array<{ __typename?: 'Partner_Partner' } & Pick<PartnerType, 'name' | 'id'>>)
  | null;

export type Course =
  | (({ __typename?: 'Course_Course' } & Pick<CourseType, 'id' | 'name' | 'promoPhotoUrl' | 'slug'> & {
        partners: Partners;
      }) & {
      specializations: Array<{ __typename?: 'Specialization_Specialization' } & Pick<SpecializationType, 'id'>>;
    } & {
      courseTypeMetadata: { __typename?: 'Course_CourseTypeMetadataWithVersion' } & {
        metadata:
          | { __typename: 'Course_ProjectMetadata' }
          | { __typename: 'Course_RhymeProjectMetadata' }
          | { __typename: 'Course_ShortFormContentMetadata' }
          | { __typename: 'Course_StandardCourseMetadata' }
          | { __typename: 'Course_VerifiedSkillsCourseMetadata' };
      };
    })
  | null;

export type PropsFromUseGetCourseById = {
  course?: Course;
  loading?: boolean;
};

const useGetCourseById = ({ courseId, skip = false }: { courseId?: string; skip?: boolean }) => {
  const { loading, data } = useQuery<GetCourseByIdForCheckoutPageQuery, GetCourseByIdForCheckoutPageQueryVariables>(
    getCourseByIdForCheckoutPage,
    {
      skip: !courseId || skip,
      variables: { id: `${courseId}` },
      context: { clientName: 'gatewayGql' },
    }
  );
  return { loading, course: data?.Course?.queryById };
};

export default useGetCourseById;
